module.exports = __webpack_public_path__ + "img/arrow-left-purple.66ba838971baac3877f30a789d927c56.svg";